import React, { useLayoutEffect, useState } from 'react';
import { Integration } from '@glomex/integration-react';
import loadAdSlot from 'app/components/ads/loadAdSlot';
import { useLayout } from 'app/contexts/LayoutContext';
import { LayoutMode } from 'app/styles/LayoutMode';
const GlomexPlayer = _ref => {
  let {
    integrationId,
    playlistId
  } = _ref;
  const [load, setLoad] = useState(false);
  const layout = useLayout();
  const isDesktop = layout !== LayoutMode.Mobile;
  useLayoutEffect(() => {
    loadAdSlot('ad-Glomex_Player', () => setLoad(true), isDesktop);
  }, [isDesktop]);
  return /*#__PURE__*/React.createElement("div", {
    id: "ad-Glomex_Player",
    "data-sentry-component": "GlomexPlayer",
    "data-sentry-source-file": "GlomexPlayer.tsx"
  }, load && /*#__PURE__*/React.createElement(Integration, {
    playlistId: playlistId,
    integrationId: integrationId
  }));
};
export default GlomexPlayer;